import React from 'react';
import * as Yup from 'yup';
import {
  ColumnSet, MutationAction, QueryAction, Resource,
  StringFieldMinMax,
  // RefField,
} from 'ants/resource';
import { CmsAssetView } from './ResourceImage';
import {
  CmsAssetSearchQuery,
  CmsAssetReadQuery,
  CmsAssetCreateMutation,
  CmsAssetUpdateMutation,
  CmsAssetNameQuery,
} from './query';

export const CmsAssetResource = Resource({
  resourceId: 'asset',
  app: 'cms',
  name: 'Asset',
  keyVal: 'CmsAsset',
  topicName: 'CmsAsset',
  storeId: 'CmsAsset',
  sportScope: false,
  columnSets: [
    ColumnSet({
      name: 'Asset',
      shape: Yup.object().shape({
        filename: StringFieldMinMax(3, 120),
        type: Yup.string().required(),
        // groups: Yup.array().of(Yup.object().shape({
        //   fields: Yup.array().of(Yup.object().shape({
        //     key: StringFieldMinMax(1, 120),
        //   })).nullable().default([]),
        // })).nullable().default([]),
      }),

    }),
  ],
  listPrimaryActions: [],
  imageRender: (item) => (<CmsAssetView item={item} />),
  queries: {
    read: QueryAction({
      query: CmsAssetReadQuery,
      resourceNamePath: 'item.asset.title',
      resourcePath: 'item.resource.hashkey',
    }),
    list: QueryAction({ query: CmsAssetSearchQuery, responsePath: 'cms_image_search' }),
    search: QueryAction({
      query: CmsAssetSearchQuery,
      resourcePath: 'resource.hashkey',
      resourceNamePath: 'name.filename',
    }),
    name: QueryAction({ query: CmsAssetNameQuery, resourceNamePath: 'cms_image_name.name' }),
  },
  mutations: {
    update: MutationAction({
      mutation: CmsAssetUpdateMutation,
      cs: ['asset'],
    }),
    create: MutationAction({ mutation: CmsAssetCreateMutation }),
  },
});
